// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".563.0.0." + {2239: "f587e4c4b173df89",2733: "32ff1ddd217ba945",2944: "450b47827bd2a1cc",5233: "18f257149b356d7e",5338: "496cb2f3391bbb53",8756: "5563be34d2c19915",9289: "eb6e8d30593806e9",}[chunkId] + ".css"
}